import React from 'react'

const LandingPage = () => {
  return (
    <div>
        <h1>Its a landing page!!</h1>
    </div>
  )
}

export default LandingPage;